import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import { connectModal } from "redux-modal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ServiceQualificationModalForm from "../../Forms/ServiceForms/ServiceQualificationModalForm/ServiceQualificationModalForm";
import BMXButton from "../../../../Components/Buttons/BMXButton/BMXButton";

const ServiceQualificationModal = (props) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([
    {
      title: t("global:qualification.step", "Kwalifikacja zlecenia"),
      error: false,
    },
  ]);
  const [isSubmit, setIsSubmit] = useState(false);
  const formName = "ServiceQualificationModalForm";
  const { handleHide, show, editable } = props;

  const buttons = () => (
    <>
      <BMXButton
        data-cy="save"
        type="submit"
        disabled={editable === false}
        onClick={() => setIsSubmit(true)}
        bmxclass="Success"
        form={formName}
      >
        {t("global:qualification.save", "ZAPISZ")}
      </BMXButton>
    </>
  );

  const setErrorHeader = (formNumber, val) => {
    steps[formNumber].error = val;
    setSteps([...steps]);
  };

  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      width={"700px"}
      height={"560px"}
      onClose={handleHide}
      header={props.header}
      buttons={buttons()}
      steps={steps}
    >
      <ServiceQualificationModalForm
        steps={steps}
        step={step}
        isSubmit={isSubmit}
        setStep={setStep}
        setErrorHeader={setErrorHeader}
        handleHide={handleHide}
        formName={formName}
        {...props}
      />
    </BMXModal>
  );
};

export default connectModal({ name: "ServiceQualificationModal" })(
  ServiceQualificationModal,
);
